// KundenPortalPage.jsx
import React from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Paper,
  Tabs,
  Tab,
} from "@mui/material";


import TabPanel from "../../components/TabPanel";
import Tab1 from "./Tabs/Tab1";

import Tab2 from "./Tabs/Tab2";
import Tab3 from "./Tabs/Tab3";

const UI = {
  blue900: "#113746",
  blue800: "var(--color-primary)",
  border: "#E6E8EB",
  placeholder: "rgba(var(--color-primary-rgb), 0.35)",
};

export default function KundenPortal() {

  const [tab, setTab] = React.useState(0);
  const uiLanguage = useSelector((state) => state.uiLanguage || "de");
  const i18n = useSelector((state) => state.i18n);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 1.5,
        mb: 4,
        overflow: "hidden",
        border: `1px solid ${UI.border}`,
      }}
    >
      {/* Top nav (tabs) */}
      <Box sx={{ bgcolor: UI.blue800, p: 0 }}>
        <Tabs
          key={uiLanguage}
          value={tab}
          onChange={(_, v) => setTab(v)}
          textColor="inherit"
          TabIndicatorProps={{ style: { backgroundColor: "#fff" } }}
          sx={{
            "& .MuiTab-root": {
              color: "#CFE1E8",
              fontWeight: 500,
              paddingLeft: 3,
              textTransform: "none",
            },
            "& .Mui-selected": { color: "#fff" },
          }}
        >
          <Tab label={i18n?.customerPortal_tabCustomerPortals} />
          <Tab label={i18n?.customerPortal_tabSettings} />
        </Tabs>
      </Box>


      <TabPanel value={tab} index={0}>
        <Tab1 />
      </TabPanel>

      <TabPanel value={tab} index={1}>
        <Tab2 />
      </TabPanel>

    </Paper>
  );
}
